import CircularProgress from '@mui/material/CircularProgress';
import { config } from '../config';
const ProgressBar = (props) => {
 
    return (
        <>
        { props.show ?  <CircularProgress  style={{ color : config.majorColor}}/> : null}
        </>
    );
};
export default ProgressBar;